<template>
  <div>
    <WidgetsDropdown />
  
    <WidgetsBrand />

    <!-- Demandes par annee et mois -->

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <b class="resFilAnonce" style="color:white">
              <center>
               <!--  <img alt="my image" src="DemandesMois.png" width="7%" /> -->
                Demande par mois | Année {{ selectedDemande.year }}:
                {{ totalDemandesAnnee }} demandes
              </center>
            </b>
          </CCardHeader>
          <CCardHeader>
            <div
              class="form-check form-check-inline"
              v-for="(annUsers, index) in anneeUsers"
              :key="'i' + index"
            >
              <div v-if="annUsers <= yearSystem">
                <input
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  :value="annUsers"
                  :id="'annUsers' + index"
                  v-model="selectedDemande.year"
                  @change="loadDemandesMois(selectedDemande.year)"
                />

                <label class="form-check-label" :for="'annUsers' + index">
                  {{ annUsers }}
                </label>
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            <card type="chart" cardCol>
              <template slot="header">
                <h3 class="card-title">
                  <!-- <i class="tim-icons icon-delivery-fast text-info"></i> -->
                  <i class="tim-icons icon-bell-55 text-primary"></i>
                </h3>
              </template>
              <apexchart
                type="bar"
                height="250"
                width="950"
                :options="chartOptionsChaqueMoisDemande"
                :series="DemandesMois"
              ></apexchart>
            </card>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

   


        <CRow>
          <CCol md="12">
            <CCard>
              <CCardHeader>
                <b class="resFil" >
                  <center>
                 <!--    <img alt="my image" src="usersMois.png" width="7%" /> -->
                    Utilisateurs par mois | Année {{ selected.year }}:
                    {{ totalUsersAnnee }} Inscriptions
                  </center>
                </b>
              </CCardHeader>
              <CCardHeader>
                <div
                  class="form-check form-check-inline"
                  v-for="(annUsers, index) in anneeUsers"
                  :key="'i' + index"
                >
                  <div v-if="annUsers <= yearSystem">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      :value="annUsers"
                      :id="'annUsers' + index"
                      v-model="selected.year"
                      @change="loadUsersMois(selected.year)"
                    />

                    <label class="form-check-label" :for="'annUsers' + index">
                      {{ annUsers }}
                    </label>
                  </div>
                </div>
              </CCardHeader>
              <CCardBody>
                <card type="chart" cardCol>
                  <template slot="header">
                    <h5 class="card-category">Users par mois</h5>
                    <h3 class="card-title">
                      <!-- <i class="tim-icons icon-delivery-fast text-info"></i> -->
                      <i class="tim-icons icon-bell-55 text-primary"></i>
                    </h3>
                  </template>
                  <apexchart
                    type="bar"
                    height="250"
                    width="950"
                    :options="chartOptionsChaqueMois"
                    :series="UMois"
                  ></apexchart>
                </card>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
 


  </div>
</template>

<script>
import MainChartExample from "./charts/MainChartExample";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
//import WidgetsBrand from './widgets/WidgetsBrand'

import axios from "axios";
import { apiDomain } from "../config";
export default {
  name: "Dashboard",
  components: {
    MainChartExample,
    WidgetsDropdown,
    // WidgetsBrand,
  },
  data() {
    return {
      anneeUsers: [
    
        "2022",
        "2023",
        "2024",
        "2025",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
      ],
      totalUsersAnnee: "",
      totalDemandesAnnee: "",
      totalPacksAnnee: "",

      PacksMois: "",
      totalDepsAnnee: "",

      yearAllUsers: [],
      UMois: {},
      ClientsMois: {},
      ClientsMois: {},

      DepsMois: {},
      DemandesMois: {},
      yearSystem: new Date().getFullYear(),

      selected: {
        year: new Date().getFullYear(),
      },

      selectedClient: {
        year: new Date().getFullYear(),
      },

      selectedPack: {
        year: new Date().getFullYear(),
      },

      selectedDemande: {
        year: new Date().getFullYear(),
      },
      selectedDep: {
        year: new Date().getFullYear(),
      },
      UsersChaqueMois: [
        {
          name: "Mois",
        },
      ],
      annee: "",
      UsersChaqueMoisnajeh: [],
      //statistique par Demande selon categorie
      serrieirAll: {},
      plombierAll: {},
      electricienAll: {},
      vitriersAll: {},

      userserrieirAll: {},
      userplombierAll: {},
      userelectricienAll: {},
      uservitriersAll: {},

      HommeAll: {},
      FemmeAll: {},
      //pourecntage
      PserrieirAll: {},
      PplombierAll: {},
      PelectricienAll: {},
      PvitriersAll: {},

      PuserserrieirAll: {},
      PuserplombierAll: {},
      PuserelectricienAll: {},
      PuservitriersAll: {},

      PHommeAll: {},
      PFemmeAll: {},

      DemandeParCat: [
        {
          name: "catégorie",
        },
      ],

      /* series4: [
        
      ], */
      chartOptions4: {
        chart: {
          height: 250,
          type: "line",
        },
        stroke: {
          width: 4,
          curve: "smooth",
        },
        xaxis: {
          categories: ["Serrurier", "Plombier", "Electricien", "Vitrier"],
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            gradientToColors: ["#FDD835"],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100],
          },
        },
        markers: {
          size: 2,
          colors: ["#FFA41B"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 4,
          },
        },
        yaxis: {
          minCat: 0,
          maxCat: 0,
          title: {
            text: "Demandes",
          },
        },
      },

      DepParCat: [
        {
          name: "catégorie",
        },
      ],

      chartOptionsDepParCat: {
        chart: {
          height: 250,
          type: "line",
        },
        stroke: {
          width: 4,
          curve: "smooth",
        },
        xaxis: {
          categories: ["Serrurier", "Plombier", "Electricien", "Vitrier"],
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            gradientToColors: ["#FDD835"],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100],
          },
        },
        markers: {
          size: 2,
          colors: ["#FFA41B"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 4,
          },
        },
        yaxis: {
          minC: 0,
          maxC: 0,
          title: {
            text: "Dépanneurs",
          },
        },
      },
      chartOptionsChaqueMoisPack: {
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        // colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [
            ["Janvier"],
            ["Février"],
            ["Mars"],
            ["Avril"],
            ["Mai"],
            ["Juin"],
            ["Juiller"],
            ["Aout"],
            ["septembre"],
            ["Octobre"],
            ["Novembre"],
            ["Décembre"],
          ],
          labels: {
            style: {
              // colors: colors,
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          minU: 0,
          maxU: 0,
        },
      },
      apiDomain: "https://panneapi20212016.panne.tn",

      chartOptionsChaqueMoisDemande: {
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        // colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [
            ["Janvier"],
            ["Février"],
            ["Mars"],
            ["Avril"],
            ["Mai"],
            ["Juin"],
            ["Juiller"],
            ["Aout"],
            ["septembre"],
            ["Octobre"],
            ["Novembre"],
            ["Décembre"],
          ],
          labels: {
            style: {
              // colors: colors,
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          minU: 0,
          maxU: 0,
        },
      },
      chartOptionsChaqueMoisDep: {
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        // colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [
            ["Janvier"],
            ["Février"],
            ["Mars"],
            ["Avril"],
            ["Mai"],
            ["Juin"],
            ["Juiller"],
            ["Aout"],
            ["septembre"],
            ["Octobre"],
            ["Novembre"],
            ["Décembre"],
          ],
          labels: {
            style: {
              // colors: colors,
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          minU: 0,
          maxU: 0,
        },
      },
      chartOptionsChaqueMoisClient: {
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        // colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [
            ["Janvier"],
            ["Février"],
            ["Mars"],
            ["Avril"],
            ["Mai"],
            ["Juin"],
            ["Juiller"],
            ["Aout"],
            ["septembre"],
            ["Octobre"],
            ["Novembre"],
            ["Décembre"],
          ],
          labels: {
            style: {
              // colors: colors,
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          minU: 0,
          maxU: 0,
        },
      },

      chartOptionsChaqueMois: {
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [
            ["Janvier"],
            ["Février"],
            ["Mars"],
            ["Avril"],
            ["Mai"],
            ["Juin"],
            ["Juiller"],
            ["Aout"],
            ["septembre"],
            ["Octobre"],
            ["Novembre"],
            ["Décembre"],
          ],
          labels: {
            style: {
              // colors: colors,
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          minU: 0,
          maxU: 0,
        },
      },

      chartOptions2: {
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        // colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [["Homme"], ["Femme"]],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          minHF: 0,
          maxHF: 0,
        },
      },
      //femme + homme
      HommeFemme: [
        {
          name: "Genre",
        },
      ],
      chartOptions1: {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: ["Homme", "Femme"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      chartOptions: {
        chart: {
          type: "donut",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      selectedd: "Month",
      tableItems: [
        {
          avatar: { url: "img/avatars/1.jpg", status: "success" },
          user: {
            name: "Yiorgos Avraamu",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "USA", flag: "cif-us" },
          usage: { value: 50, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Mastercard", icon: "cib-cc-mastercard" },
          activity: "10 sec ago",
        },
        {
          avatar: { url: "img/avatars/2.jpg", status: "danger" },
          user: {
            name: "Avram Tarasios",
            new: false,
            registered: "Jan 1, 2015",
          },
          country: { name: "Brazil", flag: "cif-br" },
          usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Visa", icon: "cib-cc-visa" },
          activity: "5 minutes ago",
        },
        {
          avatar: { url: "img/avatars/3.jpg", status: "warning" },
          user: { name: "Quintin Ed", new: true, registered: "Jan 1, 2015" },
          country: { name: "India", flag: "cif-in" },
          usage: { value: 74, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Stripe", icon: "cib-stripe" },
          activity: "1 hour ago",
        },
        {
          avatar: { url: "img/avatars/4.jpg", status: "" },
          user: { name: "Enéas Kwadwo", new: true, registered: "Jan 1, 2015" },
          country: { name: "France", flag: "cif-fr" },
          usage: { value: 98, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "PayPal", icon: "cib-paypal" },
          activity: "Last month",
        },
        {
          avatar: { url: "img/avatars/5.jpg", status: "success" },
          user: {
            name: "Agapetus Tadeáš",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "Spain", flag: "cif-es" },
          usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Google Wallet", icon: "cib-google-pay" },
          activity: "Last week",
        },
        {
          avatar: { url: "img/avatars/6.jpg", status: "danger" },
          user: {
            name: "Friderik Dávid",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "Poland", flag: "cif-pl" },
          usage: { value: 43, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Amex", icon: "cib-cc-amex" },
          activity: "Last week",
        },
      ],
      tableFields: [
        { key: "avatar", label: "", _classes: "text-center" },
        { key: "user" },
        { key: "country", _classes: "text-center" },
        { key: "usage" },
        { key: "payment", label: "Payment method", _classes: "text-center" },
        { key: "activity" },
      ],
    };
  },

  computed: {
    filteredData() {
      // params: this.selected
      var vm = this;

      const UsersChaqueMois = this.UsersChaqueMois;

      return _.filter(vm.UsersChaqueMois, function (data) {
        // }
        /* fin esle filter prix */
        var annee = vm.created_at ? data.created_at == vm.created_at : true;
        return annee;
      });
    },
    valuesUSersParMois() {
      var maxMin = this.UsersChaqueMois,
        min = _.minBy(maxMin),
        max = _.maxBy(maxMin);

      return [min, max];
    },
    loggedIn() {
      return this.$store.getters.get_loggedIn;
    },

    user() {
      return this.$store.getters.get_user;
    },
  },
  created() {
    //new
    this.loadUsersMois();
    this.loadDemandesMois();

   
  },
  mounted() {},
  methods: {
//new
loadDemandesMois: function () {
      axios

        .get(
          `${apiDomain}/api/getallDemandesParAnnee/${this.selectedDemande.year}`
        )

        .then((response) => {
          this.totalDemandesAnnee = response.data.total;
          this.DemandesMois = [
            {
              // name: "GENRE",

              data: [
                response.data.Jan,
                response.data.Fév,
                response.data.Mar,

                response.data.Avr,
                response.data.Mai,

                response.data.Jui,
                response.data.Juil,
                /* 2eme */
                response.data.Aou,
                response.data.Sep,

                response.data.Oct,
                response.data.Nov,

                response.data.Déc,
              ],
            },
          ];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    loadUsersMois: function () {
      axios

        .get(`${apiDomain}/api/getallUsersParAnnee/${this.selected.year}`)

        .then((response) => {
          this.totalUsersAnnee = response.data.total;
          this.UMois = [
            {
              // name: "GENRE",

              data: [
                response.data.Jan,
                response.data.Fév,
                response.data.Mar,

                response.data.Avr,
                response.data.Mai,

                response.data.Jui,
                response.data.Juil,
                /* 2eme */
                response.data.Aou,
                response.data.Sep,

                response.data.Oct,
                response.data.Nov,

                response.data.Déc,
              ],
            },
          ];
        })
        .catch(function (error) {
          console.log(error);
        });
    },






/* fin new */
    fetchyearAllUsers() {
      axios
        .get(`${apiDomain}/api/getYearUSer`)
        .then((response) => {
          this.yearAllUsers = response.data.data;
        })
        .catch((err) => console.log(err));
    },

    loadPackesMois: function () {
      axios

        .get(`${apiDomain}/api/getallpacksParAnnee/${this.selectedPack.year}`)

        .then((response) => {
          this.totalPacksAnnee = response.data.total;
          this.PacksMois = [
            {
              // name: "GENRE",

              data: [
                response.data.Jan,
                response.data.Fév,
                response.data.Mar,

                response.data.Avr,
                response.data.Mai,

                response.data.Jui,
                response.data.Juil,
                /* 2eme */
                response.data.Aou,
                response.data.Sep,

                response.data.Oct,
                response.data.Nov,

                response.data.Déc,
              ],
            },
          ];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
   

   
    /* client par mois et annee */

    loadClientsMois: function () {
      axios

        .get(
          `${apiDomain}/api/getallClientParAnnee/${this.selectedClient.year}`
        )

        .then((response) => {
          this.totalClientsAnnee = response.data.total;
          this.ClientsMois = [
            {
              // name: "GENRE",

              data: [
                response.data.Jan,
                response.data.Fév,
                response.data.Mar,

                response.data.Avr,
                response.data.Mai,

                response.data.Jui,
                response.data.Juil,
                /* 2eme */
                response.data.Aou,
                response.data.Sep,

                response.data.Oct,
                response.data.Nov,

                response.data.Déc,
              ],
            },
          ];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    /* client par mois et annee */

    loadDepsMois: function () {
      axios

        .get(
          `${apiDomain}/api/getallDepanneurParAnnee/${this.selectedDep.year}`
        )

        .then((response) => {
          this.totalDepsAnnee = response.data.total;
          this.DepsMois = [
            {
              // name: "GENRE",

              data: [
                response.data.Jan,
                response.data.Fév,
                response.data.Mar,

                response.data.Avr,
                response.data.Mai,

                response.data.Jui,
                response.data.Juil,
                /* 2eme */
                response.data.Aou,
                response.data.Sep,

                response.data.Oct,
                response.data.Nov,

                response.data.Déc,
              ],
            },
          ];
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    fetchUsersChaqueMoisnajeh() {
      axios
        .get(`${apiDomain}/api/usersChaqueMois`)
        .then((response) => {
          this.UsersChaqueMoisnajeh = response.data;
        })
        .catch((err) => console.log(err));
    },
    /* user sur chaque mois */

    fetchUsersChaqueMois() {
      axios
        .get(`${apiDomain}/api/usersChaqueMoin2`)
        .then((response) => {
          this.UsersChaqueMois = [
            {
              // name: "GENRE",

              data: [
                response.data.Jan,
                response.data.Fév,
                response.data.Mar,

                response.data.Avr,
                response.data.Mai,

                response.data.Jui,
                response.data.Juil,
                /* 2eme */
                response.data.Aou,
                response.data.Sep,

                response.data.Oct,
                response.data.Nov,

                response.data.Déc,
              ],
            },
          ];
        })
        .catch((err) => console.log(err));
    },

    //chart femme et homme
    fetchChartHommeFemme() {
      axios
        .get(`${apiDomain}/api/statChartFemmeHomme`)
        .then((response) => {
          this.HommeFemme = [
            {
              // name: "GENRE",
              data: [response.data.femme, response.data.homme],
            },
          ];
        })
        .catch((err) => console.log(err));
    },

    //chart Demandes par cat
    fetchstatChartDemandeParCat() {
      axios
        .get(`${apiDomain}/api/statChartDemandeParCat`)
        .then((response) => {
          this.DemandeParCat = [
            {
              // name: "GENRE",
              data: [
                response.data.serrierie,
                response.data.Plombier,
                response.data.Electricien,
                response.data.Vitrier,
              ],
            },
          ];
        })
        .catch((err) => console.log(err));
    },
    fetchstatChartDepParCat() {
      axios
        .get(`${apiDomain}/api/statChartDepParCat`)
        .then((response) => {
          this.DepParCat = [
            {
              // name: "GENRE",
              data: [
                response.data.serrierie,
                response.data.Plombier,
                response.data.Electricien,
                response.data.Vitrier,
              ],
            },
          ];
        })
        .catch((err) => console.log(err));
    },

    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },

    //sattistique Demande par categorie
    fetchSerrierie() {
      fetch(`${apiDomain}/api/statistiqueserririeDemandeParCat`)
        .then((res) => res.json())
        .then((res) => {
          this.serrieirAll = res.serririe;
        })
        .catch((err) => console.log(err));
    },

    fetchPlombier() {
      fetch(`${apiDomain}/api/statistiquePlombierDemandeParCat`)
        .then((res) => res.json())
        .then((res) => {
          this.plombierAll = res.Plombier;
        })
        .catch((err) => console.log(err));
    },

    fetchElectricien() {
      fetch(`${apiDomain}/api/statistiqueElectricienDemandeParCat`)
        .then((res) => res.json())
        .then((res) => {
          this.electricienAll = res.Electricien;
        })
        .catch((err) => console.log(err));
    },

    fetchVitrier() {
      fetch(`${apiDomain}/api/statistiqueVitrierDemandeParCat`)
        .then((res) => res.json())
        .then((res) => {
          this.vitriersAll = res.Vitrier;
        })
        .catch((err) => console.log(err));
    },

    //sattistique users par categorie
    fetchUserVitrier() {
      fetch(`${apiDomain}/api/statistiqueUserVitrier`)
        .then((res) => res.json())
        .then((res) => {
          this.uservitriersAll = res.UserVitrier;
        })
        .catch((err) => console.log(err));
    },

    fetchUserElectricien() {
      fetch(`${apiDomain}/api/statistiqueUserElectricien`)
        .then((res) => res.json())
        .then((res) => {
          this.userelectricienAll = res.UserElectricien;
        })
        .catch((err) => console.log(err));
    },

    fetchUserPlombier() {
      fetch(`${apiDomain}/api/statistiqueUserPlombier`)
        .then((res) => res.json())
        .then((res) => {
          this.userplombierAll = res.UserPlombier;
        })
        .catch((err) => console.log(err));
    },

    fetchUserSerrierie() {
      fetch(`${apiDomain}/api/statistiqueUserSerrierie`)
        .then((res) => res.json())
        .then((res) => {
          this.userserrieirAll = res.UserSerrurier;
        })
        .catch((err) => console.log(err));
    },

    //statistique homme et femme
    //sattistique Demande par categorie
    fetchHomme() {
      fetch(`${apiDomain}/api/statistiqueHomme`)
        .then((res) => res.json())
        .then((res) => {
          this.HommeAll = res.Homme;
        })
        .catch((err) => console.log(err));
    },

    fetchFemme() {
      fetch(`${apiDomain}/api/statistiqueFemme`)
        .then((res) => res.json())
        .then((res) => {
          this.FemmeAll = res.Femme;
        })
        .catch((err) => console.log(err));
    },
    //percentage
    fetchPSerrierie() {
      fetch(`${apiDomain}/api/percentageDemandeserrierie`)
        .then((res) => res.json())
        .then((res) => {
          this.PserrieirAll = res.PourcentageDemandeserrierie;
        })
        .catch((err) => console.log(err));
    },

    fetchPPlombier() {
      fetch(`${apiDomain}/api/percentageDemandePlombier`)
        .then((res) => res.json())
        .then((res) => {
          this.PplombierAll = res.PourcentageDemandePlombier;
        })
        .catch((err) => console.log(err));
    },

    fetchPElectricien() {
      fetch(`${apiDomain}/api/percentageDemandeElectricien`)
        .then((res) => res.json())
        .then((res) => {
          this.PelectricienAll = res.PourcentageDemandeElectricien;
        })
        .catch((err) => console.log(err));
    },

    fetchPVitrier() {
      fetch(`${apiDomain}/api/percentageDemandeVitrier`)
        .then((res) => res.json())
        .then((res) => {
          this.PvitriersAll = res.PourcentageDemandeVitrier;
        })
        .catch((err) => console.log(err));
    },

    //sattistique users par categorie
    fetchPUserVitrier() {
      fetch(`${apiDomain}/api/percentageUserVitrier`)
        .then((res) => res.json())
        .then((res) => {
          this.PuservitriersAll = res.PourcentageUserVitrier;
        })
        .catch((err) => console.log(err));
    },

    fetchPUserElectricien() {
      fetch(`${apiDomain}/api/percentageUserElectricien`)
        .then((res) => res.json())
        .then((res) => {
          this.PuserelectricienAll = res.PourcentageUserElectricien;
        })
        .catch((err) => console.log(err));
    },

    fetchPUserPlombier() {
      fetch(`${apiDomain}/api/percentageUserPlombier`)
        .then((res) => res.json())
        .then((res) => {
          this.PuserplombierAll = res.PourcentageUserPlombier;
        })
        .catch((err) => console.log(err));
    },

    fetchPUserSerrierie() {
      fetch(`${apiDomain}/api/percentageUserSerrurier`)
        .then((res) => res.json())
        .then((res) => {
          this.PuserserrieirAll = res.PourcentageUserSerrurier;
        })
        .catch((err) => console.log(err));
    },

    //statistique homme et femme
    //sattistique Demande par categorie
    fetchPHomme() {
      fetch(`${apiDomain}/api/percentageUserHomme`)
        .then((res) => res.json())
        .then((res) => {
          this.PHommeAll = res.PourcentageUserHomme;
        })
        .catch((err) => console.log(err));
    },

    fetchPFemme() {
      fetch(`${apiDomain}/api/percentageUserFemme`)
        .then((res) => res.json())
        .then((res) => {
          this.PFemmeAll = res.PourcentageUserFemme;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style scoped>
.resFil {
  border-radius: 24px;
  padding: 12px;
  max-width: 800px;
  display: inline-block;
  background-color: #9f9e96;
  color: #0e0d0d ;
}
.resFilClient {
  border-radius: 24px;
  padding: 12px;
  max-width: 800px;
  display: inline-block;
  background-color: rgb(255 54 54);;
}

.resFilDep {
  border-radius: 24px;
  padding: 12px;
  width: 397px;
  display: inline-block;
  background-color: rgb(255, 183, 68);
}
.resFilAnonce {
  border-radius: 24px;
  padding: 12px;
  width: 397px;
  display: inline-block;
  background-color: rgb(255 54 54) !important;
}

.resFilPack {
  border-radius: 24px;
  padding: 12px;
  width: 397px;
  color: white;
  display: inline-block;
  background-color: #4a0f0f;
}
</style>
